import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f9f8f8e2"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode(" 엔젤리그 지갑 ")
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 보유 예수금 ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 원 ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 사용 가능 ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 원 ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 사용 대기 ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 원 ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 출금 대기 ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" 원 ")
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "slide_down",
  src: "/assets/icon/btn_down_small.png",
  srcset: "/assets/icon/btn_down_small@2x.png 2x,/assets/icon/btn_down_small@3x.png 3x"
}, null, -1))
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" 원 ")
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" 아직 사용 내역이 없습니다 ")
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" 예수금을 충전하시면 ")
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" 조합원 자격 거래에 사용하실 수 있어요! ")
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" 충전하기 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ag_refresher = _resolveComponent("ag-refresher")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ag_text_s = _resolveComponent("ag-text-s")!
  const _component_ag_box_s = _resolveComponent("ag-box-s")!
  const _component_ag_img = _resolveComponent("ag-img")!
  const _component_ag_button_s = _resolveComponent("ag-button-s")!
  const _component_wallet_request_modal = _resolveComponent("wallet-request-modal")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_content, { fullscreen: true }, {
        default: _withCtx(() => [
          _createVNode(_component_ag_refresher, {
            slot: "fixed",
            onRefresh: _cache[0] || (_cache[0] = ($event: any) => (_ctx.doRefresh($event)))
          }),
          _createVNode(_component_ag_box_s, {
            css: {
          p: '20px',
          height: '280px',
        },
            style: _normalizeStyle({
          background: 'linear-gradient(142.61deg, #4360EC 6.35%, #3AC0FA 94.57%)',
        })
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ag_box_s, {
                css: {
            textAlign: 'left',
            position: 'relative',
            color:'white',
            mb:'24px',

          },
                style: {
            display:'flex',
            direction:'row',
            alignItems:'center',
          },
                onClick: _cache[1] || (_cache[1] = ($event: any) => {_ctx.router.push({name:'MyPage'});_ctx.$clickTrackEvent({'clickArea':'헤더', 'clickContent':'뒤로가기', clickScreen: _ctx.clickScreen})})
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_icon, {
                    style: {"color":"white","width":"18px","height":"18px"},
                    icon: _ctx.chevronBack
                  }, null, 8, ["icon"]),
                  _createVNode(_component_ag_text_s, { css: {
              ml:'16px'
            } }, {
                    default: _withCtx(() => [
                      _hoisted_1
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ag_box_s, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ag_box_s, {
                    class: "space-between",
                    css: {
              color:'white'
            }
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ag_box_s, { css: {
                typography:'tit14b'
              } }, {
                        default: _withCtx(() => [
                          _hoisted_2
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ag_box_s, { css: {
                typography:'tit26r'
              } }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ag_text_s, { css: {typography:'num26eb'} }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$filters.currency(_ctx.walletInfo.currentBalance)), 1)
                            ]),
                            _: 1
                          }),
                          _hoisted_3
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ag_box_s, { css: {
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'flex-start',
              justifyContent: 'space-between',
              m:'6px 0px',
              color:'white'
            } }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ag_box_s, {
                        css: {
                typography:'text14r',
                width: '164px',
                height: '48px',
                bg: `${_ctx.withdrawRequested?'rgba(255, 255, 255, 0.2);':'rgba(16, 29, 92, 0.3)'}`,
                borderRadius: '6px',
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'center',
                alignItems: 'center',
              },
                        class: _normalizeClass({disabled:!_ctx.walletInfo.currentBalance}),
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.callWalletFunction('withdraw')))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.withdrawRequested?`출금 취소`: `- 출금하기`), 1)
                        ]),
                        _: 1
                      }, 8, ["css", "class"]),
                      _createVNode(_component_ag_box_s, {
                        css: {
                typography:'text14r',
                width: '164px',
                height: '48px',
                bg: `${_ctx.depositRequested?'rgba(255, 255, 255, 0.2);':'rgba(16, 29, 92, 0.3)'}`,
                borderRadius: '6px',
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'center',
                alignItems: 'center',
              },
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.callWalletFunction('deposit')))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.depositRequested?`충전 취소`: `+ 충전하기`), 1)
                        ]),
                        _: 1
                      }, 8, ["css"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ag_box_s, { css: {
              width: '100%',
              height: '1px',
              bg: '#EEF1F7',
              opacity:'0.2',
              my:'16px'
            } }, null, 8, ["css"]),
                  _createVNode(_component_ag_box_s, {
                    class: "space-between",
                    css: {
              color:'white'
            }
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ag_box_s, { css: {
                typography:'text14r', opacity:'0.8', mb:'5px'
              } }, {
                        default: _withCtx(() => [
                          _hoisted_4
                        ]),
                        _: 1
                      }, 8, ["css"]),
                      _createVNode(_component_ag_box_s, { css: {
                typography:'text16r'
              } }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ag_text_s, { css: {typography:'num16eb'} }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$filters.currency(_ctx.walletInfo.usableBalance)), 1)
                            ]),
                            _: 1
                          }),
                          _hoisted_5
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ag_box_s, {
                    class: "space-between",
                    css: {
              color:'white'
            }
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ag_box_s, { css: {
                typography:'text14r', opacity:'0.8', mb:'5px'
              } }, {
                        default: _withCtx(() => [
                          _hoisted_6
                        ]),
                        _: 1
                      }, 8, ["css"]),
                      _createVNode(_component_ag_box_s, { css: {
                typography:'text16r'
              } }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ag_text_s, { css: {typography:'num16eb'} }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$filters.currency(_ctx.walletInfo.useRequestAmount)), 1)
                            ]),
                            _: 1
                          }),
                          _hoisted_7
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ag_box_s, {
                    class: "space-between",
                    css: {
              color:'white'
            }
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ag_box_s, { css: {
                typography:'text14r', opacity:'0.8', mb:'5px'
              } }, {
                        default: _withCtx(() => [
                          _hoisted_8
                        ]),
                        _: 1
                      }, 8, ["css"]),
                      _createVNode(_component_ag_box_s, { css: {
                typography:'text16r'
              } }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ag_text_s, { css: {typography:'num16eb'} }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$filters.currency(_ctx.walletInfo.withdrawRequestAmount)), 1)
                            ]),
                            _: 1
                          }),
                          _hoisted_9
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["style"]),
          (Object.keys(_ctx.transactionHistory).length)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createVNode(_component_ag_box_s, { css: {
            display:'flex',
            justifyContent:'space-between',
            p:'16px 20px',
          } }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ag_box_s),
                    _createVNode(_component_ag_box_s, {
                      css: {
              color: '#5E6068',
              display: 'flex',
              alignItems: 'center',
            },
                      onClick: _cache[4] || (_cache[4] = ($event: any) => {_ctx.$clickTrackEvent({'clickArea':'입출금내역', 'clickContent':'보기옵션', clickScreen: _ctx.clickScreen});_ctx.createModal('filter')})
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", null, _toDisplayString(_ctx.viewOption) + " · " + _toDisplayString(_ctx.viewType), 1),
                        _hoisted_10
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ag_box_s, { css: {px:'20px'} }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.entries(_ctx.transactionHistory), (key) => {
                      return (_openBlock(), _createBlock(_component_ag_box_s, {
                        key: key[0],
                        css: {mb:'32px'}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ag_box_s, { css: {color:'skyPurple1', typography:'text14r'} }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(key[0]), 1)
                            ]),
                            _: 2
                          }, 1024),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(key[1], (list) => {
                            return (_openBlock(), _createBlock(_component_ag_box_s, {
                              key: list.accountTransactionId,
                              css: {
                display:'flex',
                displayDirection:'row',
                justifyContent:'space-between',
                py: '12px',
                height:'74px',
                borderBottom: '1px solid #EEF1F7',
              }
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ag_box_s, { css: {
                  width:'40px',
                  color:'gray3',
                  typography:'text13r',

                } }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.getFormattedDate(list.accountTransactionAt, 'MM.DD')), 1)
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_component_ag_box_s, { css: {
                  width:'130px',
                  color:'black',
                  typography:'text16r',
                } }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ag_box_s, null, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(list.transactionLabel), 1)
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createVNode(_component_ag_box_s, {
                                      css: {
                    color:'skyPurple1',
                    typography:'text13r',
                    //FIXME: textOverflow 이모션 적용 안됨 ㅠㅠ
                    //textOverflow:'ellipsis',
                    overflow: 'hidden',
                    whiteSpace: 'nowrap'
                  },
                                      style: {
                    textOverflow:'ellipsis'
                  }
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(list.transactionRelationInfo), 1)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_component_ag_box_s),
                                _createVNode(_component_ag_box_s, {
                                  css: {
                  minWidth:'100px',
                  maxWidth:'140px',
                  textAlign:'right',
                  typography:'text16r',
                  color: Number(list.amount)>0?'primary':'black',
                  opacity: (list.status==='request'?'0.3':'1'),
                }
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ag_box_s, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_ag_text_s, { css: {
                      typography:'num16eb',
                    } }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.$filters.currency(list.amount)), 1)
                                          ]),
                                          _: 2
                                        }, 1024),
                                        _hoisted_11
                                      ]),
                                      _: 2
                                    }, 1024),
                                    (list.status!=='request')
                                      ? (_openBlock(), _createBlock(_component_ag_box_s, {
                                          key: 0,
                                          css: {
                    typography:'text13r',
                    color:'gray3'
                  }
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.$filters.currency(list.currentBalance)) + " 원 ", 1)
                                          ]),
                                          _: 2
                                        }, 1024))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 2
                                }, 1032, ["css"])
                              ]),
                              _: 2
                            }, 1024))
                          }), 128))
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ]),
                  _: 1
                })
              ], 64))
            : (_openBlock(), _createBlock(_component_ag_box_s, {
                key: 1,
                css: {
            textAlign:'center', my:'50px',
            typography:'text16r',
            color:'gray2',
            px:'20px',
          }
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ag_box_s, { css: {
              typography:'tit20b',
              color:'black',
              mb:'24px'
            } }, {
                    default: _withCtx(() => [
                      _hoisted_12
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ag_box_s, null, {
                    default: _withCtx(() => [
                      _hoisted_13
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ag_box_s, null, {
                    default: _withCtx(() => [
                      _hoisted_14
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ag_img, {
                    css: {
              mt:'24px',
              width: '226px !important',
              height: '188px !important',
              display: 'inline-block',
            },
                    src: "/assets/image/group330@3x.png"
                  }),
                  _createVNode(_component_ag_button_s, {
                    css: {block: 'md', width: '100%', corner: 'full'},
                    onClickCapture: _cache[5] || (_cache[5] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'보유 주식 팔기', 'clickContent':`충전하기`});_ctx.callWalletFunction('deposit');})
                  }, {
                    default: _withCtx(() => [
                      _hoisted_15
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })),
          _createVNode(_component_wallet_request_modal, {
            "open-type": _ctx.openType,
            "is-open": _ctx.depositRequestOpen,
            onCloseWithResult: _ctx.branchResult,
            onClose: _cache[6] || (_cache[6] = () => _ctx.depositRequestOpen = false)
          }, null, 8, ["open-type", "is-open", "onCloseWithResult"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}